// Coach invite settings, team list, plan presets and company + manager creation.
// Errors carry `status` so forms can show a taken code (409) next to the field.
import API_BASE_URL from '../config/api';

const BASE = API_BASE_URL.endsWith('/api') ? API_BASE_URL : `${API_BASE_URL}/api`;

async function request(endpoint, { method = 'GET', body } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  try {
    const { authClient } = await import('../lib/authClient');
    const token = await authClient.getAccessToken();
    if (token) headers.Authorization = `Bearer ${token}`;
  } catch (_) { /* no token */ }

  const response = await fetch(`${BASE}${endpoint}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    const err = new Error(data.error || data.message || `HTTP ${response.status}`);
    err.status = response.status;
    throw err;
  }
  if (response.status === 204) return null;
  return response.json();
}

/** Response: { settings, presets, suggested_code } */
export const DietitianSettings = {
  getMine() {
    return request('/me/dietitian-settings');
  },
  saveMine(patch) {
    return request('/me/dietitian-settings', { method: 'PUT', body: patch });
  },
  get(profileId) {
    return request(`/dietitians/${encodeURIComponent(profileId)}/settings`);
  },
  save(profileId, patch) {
    return request(`/dietitians/${encodeURIComponent(profileId)}/settings`, { method: 'PUT', body: patch });
  },
};

export const Team = {
  /** { company, members: [{ profile_id, name, role, is_placeholder, invite_code, client_link, pricing_preset_id, client_count }] } */
  get(companyId) {
    const qs = companyId ? `?companyId=${encodeURIComponent(companyId)}` : '';
    return request(`/team${qs}`);
  },
};

export const PricingPresets = {
  list({ all = false } = {}) {
    return request(`/pricing-presets${all ? '?all=true' : ''}`);
  },
  create(preset) {
    return request('/pricing-presets', { method: 'POST', body: preset });
  },
  update(id, patch) {
    return request(`/pricing-presets/${encodeURIComponent(id)}`, { method: 'PUT', body: patch });
  },
};

export const CompanyOnboarding = {
  /** sys_admin: { company, invite: { code, email, signup_link } } */
  createWithManager({ name, managerEmail }) {
    return request('/companies/with-manager', { method: 'POST', body: { name, manager_email: managerEmail } });
  },
};
